<h1 class="title">Analysresultat 14 dagar</h1>
<app-table
  [config]="tableConfig"
  [expandedRows]="expanded"
  [loading]="loading"
  [lazy]="true"
  [totalRecordsLazy]="paginationLength"
  [pagination]="paginationLength !== undefined && paginationLength !== 0"
  (sortEvent)="sort($event)"
  (lazyExpandEvent)="lazyExpand($event)"
>
</app-table>
